<template>
  <div class="layout">
    <Header
      v-show="shouldShowLayout"
      :shouldShowSideBar="shouldShowSideBar"
      :sections="sections"
      :nowSection="nowSection"
      @toggleSideBar="toggleSideBar"
    />
    <Sidebar
      v-show="shouldShowLayout"
      :shouldShowSideBar="shouldShowSideBar"
      :sections="sections"
      :nowSection="nowSection"
      v-click-outside="handleClickOutside"
    />
    <slot />
    <a class="book" href="https://tyreplus.com.tw/dealers" target="_blank">
      <img src="../assets/book.png" />
    </a>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import Header from "./Header.vue";
import Sidebar from "./SideBar.vue";
export default {
  name: "Layout",
  components: {
    Header,
    Sidebar,
  },
  directives: {
    ClickOutside,
  },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    nowSection: {
      type: Array,
      default: () => [1, 1],
    },
    shouldShowLayout: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      shouldShowSideBar: false,
    };
  },
  methods: {
    toggleSideBar() {
      this.shouldShowSideBar = !this.shouldShowSideBar;
    },
    handleClickOutside(e) {
      if (e.target.className === "header__burger mobile open") return;
      this.shouldShowSideBar = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  min-width: 100vw;
  max-width: 100vw;
  top: 0;
  left: 0;

  .book {
    position: fixed;
    bottom: 43px;
    right: 15px;
    img {
      width: 65px;
      @media (min-width: 768px) {
        width: 100px;
      }
    }
    @media (min-width: 768px) {
      bottom: 7px;
      right: 24px;
    }
  }
}
</style>
